/**
 * Clinical Live Orders Popup - JavaScript
 */

// Array of sample orders for The Clinical Pack
const orders = [
    { name: "Peter", location: "FL", product: "The Clinical Pack", time: "11 minutes ago" },
    { name: "Jason", location: "CA", product: "The Clinical Pack", time: "14 minutes ago" },
    { name: "Anthony", location: "CA", product: "The Clinical Pack", time: "18 minutes ago" },
    { name: "Christopher", location: "FL", product: "The Clinical Pack", time: "23 minutes ago" },
    { name: "Dylan", location: "FL", product: "The Clinical Pack", time: "26 minutes ago" },
    { name: "Anthony", location: "CO", product: "The Clinical Pack", time: "31 minutes ago" },
    { name: "Luis", location: "TX", product: "The Clinical Pack", time: "38 minutes ago" },
    { name: "Shawn", location: "MD", product: "The Clinical Pack", time: "10 minutes ago" },
    { name: "Brian", location: "CA", product: "The Clinical Pack", time: "16 minutes ago" },
    { name: "Jacob", location: "AZ", product: "The Clinical Pack", time: "22 minutes ago" },
    { name: "Mike", location: "ON", product: "The Clinical Pack", time: "28 minutes ago" },
    { name: "Alfredo", location: "TX", product: "The Clinical Pack", time: "34 minutes ago" },
    { name: "Matt", location: "AZ", product: "The Clinical Pack", time: "40 minutes ago" },
    { name: "Doug", location: "MN", product: "The Clinical Pack", time: "46 minutes ago" },
    { name: "Joshua", location: "AL", product: "The Clinical Pack", time: "10 minutes ago" },
    { name: "Nasario", location: "TX", product: "The Clinical Pack", time: "13 minutes ago" },
    { name: "Luis", location: "TX", product: "The Clinical Pack", time: "16 minutes ago" },
    { name: "Will", location: "CA", product: "The Clinical Pack", time: "20 minutes ago" },
    { name: "Sanford", location: "NY", product: "The Clinical Pack", time: "23 minutes ago" },
    { name: "Sam", location: "MA", product: "The Clinical Pack", time: "26 minutes ago" },
    { name: "Rogelio", location: "CA", product: "The Clinical Pack", time: "30 minutes ago" },
    { name: "Larinza", location: "VA", product: "The Clinical Pack", time: "33 minutes ago" },
    { name: "Winston", location: "IL", product: "The Clinical Pack", time: "37 minutes ago" },
    { name: "Richard", location: "CA", product: "The Clinical Pack", time: "40 minutes ago" },
    { name: "Trent", location: "KY", product: "The Clinical Pack", time: "44 minutes ago" },
    { name: "Sholom", location: "NY", product: "The Clinical Pack", time: "47 minutes ago" },
    { name: "Anthony", location: "IL", product: "The Clinical Pack", time: "50 minutes ago" },
    { name: "Shawn", location: "MD", product: "The Clinical Pack", time: "53 minutes ago" },
    { name: "Brian", location: "CA", product: "The Clinical Pack", time: "57 minutes ago" },
    { name: "Jacob", location: "AZ", product: "The Clinical Pack", time: "60 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/The_Clinical_Pack_Zoom.png?v=1733351351" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
